import { render } from "./ModuleStatuses.vue?vue&type=template&id=70442154&scoped=true&ts=true"
import script from "./ModuleStatuses.vue?vue&type=script&lang=ts"
export * from "./ModuleStatuses.vue?vue&type=script&lang=ts"

import "./ModuleStatuses.vue?vue&type=style&index=0&id=70442154&scoped=true&lang=css"
import "./ModuleStatuses.vue?vue&type=style&index=1&id=70442154&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70442154"]])

export default __exports__